// redux/slices/settingSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../../config";
import { apiEndPoints } from "../../../helpers/constants";
import { authHeaders } from "../../../helpers/axios";
import { notify } from "../../../helpers/commonFunctions";

// Async thunk to get settings by category
export const reqToGetSettings = createAsyncThunk(
  "settings/reqToGetSettings",
  async ({ category, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.settings}?category=${category}`,
        authHeaders()
      );
      onSuccess?.(response.data);
      return response.data;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure?.(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

export const reqToUpdateSettings = createAsyncThunk(
  "settings/reqToUpdateSettings",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BASE_URL}${apiEndPoints.settings}`,
        data,
        authHeaders()
      );

      notify("Settings updated successfully!", "success");
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      if (onFailure) onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

const settingSlice = createSlice({
  name: "settings",
  initialState: {
    loader: false,
    error: null,
    settingDetails: [],
    updateStatus: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(reqToGetSettings.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetSettings.fulfilled, (state, action) => {
      state.loader = false;
      state.settingDetails = action.payload.result || [];
    });
    builder.addCase(reqToGetSettings.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // Extra reducers for update
    builder.addCase(reqToUpdateSettings.pending, (state) => {
      state.loader = true;
      state.updateStatus = null;
    });
    builder.addCase(reqToUpdateSettings.fulfilled, (state, action) => {
      state.loader = false;
      state.updateStatus = "success";
      if (
        Array.isArray(state.settingDetails) &&
        Array.isArray(action.meta.arg.data)
      ) {
        action.meta.arg.data.forEach((updated) => {
          const existing = state.settingDetails.find(
            (s) => s.name === updated.name
          );
          if (existing) {
            existing.value = updated.value; // update in place
          } else {
            // if not found, push it (in case new setting was added)
            state.settingDetails.push(updated);
          }
        });
      }
    });
    builder.addCase(reqToUpdateSettings.rejected, (state, action) => {
      state.loader = false;
      state.updateStatus = "failed";
      state.error = action.payload;
    });
  },
});

export default settingSlice.reducer;
